var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamtasiaLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#CamtasiaLogo_svg__a)",
  d: "M29 0a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.604 4.147 6 9h16.064a.46.46 0 0 0 .333-.147l3.796-3.999a.51.51 0 0 0 .105-.538A.49.49 0 0 0 25.86 4H10.94a.46.46 0 0 0-.336.147M10.604 27.853 6 23h16.064a.46.46 0 0 1 .333.147l3.796 3.999a.51.51 0 0 1 .105.538.49.49 0 0 1-.438.316H10.94a.46.46 0 0 1-.332-.147"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11 9H6v14h5z",
  opacity: 0.74
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "CamtasiaLogo_svg__a",
  x1: 0,
  x2: 0,
  y1: 0,
  y2: 32,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#97C93D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D9544"
})))));
export default SvgCamtasiaLogo;